// umlaut-check: skip — "SicherheitAbzeichen" ist ein Komponentenname
// (technischer Bezeichner), bleibt ASCII; sichtbare Texte kommen aus
// sicherheitLabel() und tragen Umlaute korrekt.

import React from "react";
import {sicherheitLabel} from "./format.js";

/**
 * Ruhige, einheitliche Kennzeichnung, worauf eine Kennzahl beruht (Meeting
 * 22.09.2026, Punkt 8: "Gerade die Daten, die jetzt aktuell nicht sicher
 * sind... das muss ganz klar sein"). Bewusst EINE neutrale Optik für jeden
 * Wert der Skala (ist, gemessen, gepflegt, errechnet, aus Datei, angenommen)
 * - kein rot/gelb nach Schweregrad, keine Warnung. Die Kennzahl selbst
 * bleibt unverändert lesbar, das Abzeichen ergänzt nur die Herkunft, direkt
 * sichtbar statt nur im Tooltip.
 */
export default function SicherheitAbzeichen({sicherheit, className = ""}) {
    if (!sicherheit) {
        return null;
    }

    return <span className={`badge text-bg-light border text-muted fw-normal ${className}`}>{sicherheitLabel(sicherheit)}</span>;
}
